<template>
  <div data-testid="overview-header-skeleton">
    <HgSkeleton height="24px" width="125px" />
    <div :class="$style.headerWrapper">
      <HgSkeleton height="32px" width="269px" />
      <HgSkeleton height="36px" :class="$style.withRounded" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { HgSkeleton } from '@smg-real-estate/domus';
</script>

<style lang="scss" module>
@use '@/assets/variables' as *;

.headerWrapper {
  display: flex;
  justify-content: space-between;
  margin-top: $space-100;
  margin-bottom: $space-100;
}

.withRounded[class*='HgSkeleton_skeleton'] {
  width: 36px;
  border-radius: $border-radius;
  @include grid-media-query(sm) {
    display: block;
    width: 185px;
  }
}
</style>
